import { render, staticRenderFns } from "./templateTagNew.vue?vue&type=template&id=03aac72c&scoped=true&"
import script from "./templateTagNew.vue?vue&type=script&lang=js&"
export * from "./templateTagNew.vue?vue&type=script&lang=js&"
import style0 from "./templateTagNew.vue?vue&type=style&index=0&id=03aac72c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03aac72c",
  null
  
)

export default component.exports